import { render } from "./LinkOauthReturnView.vue?vue&type=template&id=1cf49a9c"
import script from "./LinkOauthReturnView.vue?vue&type=script&lang=js"
export * from "./LinkOauthReturnView.vue?vue&type=script&lang=js"

import exportComponent from "/home/walter/projects/finances-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__